import { createContext as e, useContext as t } from "react";
const o = e({
  analyzeDataset: void 0,
  uploadDataset: void 0
}), a = o.Provider, n = () => t(o);
export {
  o as WorkerContext,
  a as WorkerProvider,
  n as useWorker
};
//# sourceMappingURL=WorkerContext.js.map
